import { Grid, DataGrid, Typography, Grow } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";

import { useGetByTypesQuery } from "../../services/wordsApi";

import useStyles from "./style";

const Typecards = ({ word, type }) => {
  const classes = useStyles();
  let { data } = useGetByTypesQuery({ word, type });

  if (data === undefined) {
    return <CircularProgress color="inherit" />;
  }

  // console.log(data);

  let typeData = [];
  if (
    data[type] !== undefined &&
    data[type][0] !== undefined &&
    data[type][0]["definition"] !== undefined &&
    type === "definitions"
  ) {
    for (let i = 0; i < data[type].length; i++) {
      // console.log(data[type][i]["definition"]);
      typeData.push(data[type][i]["definition"]);
    }
  } else if (data[type] !== undefined && type === "rhymes") {
    // console.log(data[type]["all"]);
    typeData = data[type]["all"];
  } else {
    typeData = data[type];
    // console.log(data[type]);
  }

  if (typeData === []) {
    return <></>;
  }

  return (
    <>
      <Grid container className={classes.displaybar}>
        <Typography
          variant="h5"
          style={{ width: "100%", marginBottom: 20 }}
        >{`All ${type} are here...`}</Typography>
        <div className={classes.box}>
          {typeData?.map((source, i) => (
            <div className={classes.card} key={i}>
              <p>{source}</p>
            </div>
          ))}
        </div>
      </Grid>
    </>
  );
};

export default Typecards;
